<template>
  <div class="warp">
    <!--导航栏 start-->
    <van-nav-bar left-text="返回" fixed title="批量上下架菜品" left-arrow @click-left="onClickLeft">
      <!--通过插槽自定义导航栏右侧的内容 end-->
    </van-nav-bar>
    <!--导航栏 end-->
    <!-- 列表 start-->
    <van-grid :column-num="4" :border="false" style="margin-top: 1rem">
      <van-grid-item text="操作">
        <!-- 控制全选/全反选的 -->
        <van-checkbox ref="all_status" v-model="checked" @click="checkedAll" />
      </van-grid-item>
      <van-grid-item text="菜品名称" />
      <van-grid-item text="菜品价格" />
      <van-grid-item text="状态" />
    </van-grid>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="init">
      <van-cell v-for="item in list" :key="item.id">
        <van-grid :column-num="4" :border="false">
          <van-grid-item>
            <van-checkbox ref="item_status" v-model="item.checked" @click="changeStatus(item.checked)" />
          </van-grid-item>
          <van-grid-item :text="item.name" />
          <van-grid-item :text="'￥'+item.price" />
          <van-grid-item :text="['下架','上架'][item.status]" />

          <!--                    <van-grid-item v-if="item.is_audit_status == 1">审核中</van-grid-item>-->
          <!--                    <van-grid-item v-if="item.is_audit_status == 0">已审核</van-grid-item>-->
        </van-grid>
      </van-cell>
    </van-list>
    <!-- 列表 end-->
    <div class="bottom">
      <div class="down" @click="getCheckedArr(0)">下架</div>
      <div class="up" @click="getCheckedArr(1)">上架</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { List, Grid, GridItem, Dialog, Notify } from 'vant';
import Config from "../../../config";
// import VueCookie from "vue-cookies";

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(List);

export default {
  name: "editFoodStatus",
  data() {
    return {
      checked: false,
      list: [],
      page: 1,
      limit: 10,
      loading: false,
      finished: false,
    }
  },
  methods: {
    checkedAll() {
      console.log(this.checked)
      console.log(this.$refs.all_status)
      this.$refs.all_status.toggle(this.checked)
      this.$refs.item_status.map(item => {
        item.toggle(this.checked)
      })
      //   console.log(this.list)

    },
    // 选择菜品
    changeStatus(status) {
      console.log(status)
      // 判断一下是不是取消选中了
      if (!status) {
        this.$refs.all_status.toggle(false);
      } else {
        var checked_num = 0;
        //  判断菜品是否全部都是选中状态
        this.list.map(v => {
          if (v.checked) {
            checked_num++
          }
        })
       
        if (checked_num == this.list.length) {
          this.$refs.all_status.toggle(true)
        } else {
          this.$refs.all_status.toggle(false)
        }
      }

    },
    // 
    // 提取选中的菜品
    getCheckedArr(type) {
      let checkedIds = [];
      this.list.map(v => {
        if (v.checked) {
          checkedIds.push(v.id)
        }
      })
      var params = {
        id: checkedIds,
        status: type
      }
      this.$http.post('/wechat/api.store_food/editFoodStatus', params).then(response => {
		if (response && response.body.code== 200) {
		    Notify({type: 'success', message: response.body.msg});
		    setTimeout(()=>{
		        this.$router.go(0)
		    },200)
		
		}else {
		    Notify({type: 'danger',message:response.body.msg});
		}
      })
    },
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push('/FoodList');
    },
    init() {
      var that = this;
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      this.$http.post('/wechat/api.store_food/listFood', {

        // id: salesmanInfo.id,
        pageNum: that.page,
        pageSize: that.limit

      }).then(response => {
        // 加载状态结束
        that.loading = false;
        // console.log(response.data.data)
        that.list = that.list.concat(response.data.rows)
        // 页码
        that.page++;
        // this.finished = true;
        if (response.data.rows.length < that.limit) {
          that.finished = true;
        }
      });
    },

  },

}
</script>

<style scoped>
.warp {
  padding-bottom: 1.4rem;
}
.warp .bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 1.4rem;
  background-color: #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  font-size: 0.5rem;
}
.warp .bottom div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
}
</style>
